<template>
  <div>
    <loading :active.sync="isLoading" color="#64B9B0"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
         <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/adm_master/empresas">Empresas</router-link>
          </li>
          <li class="breadcrumb-item active">Criar nova Empresa</li>
        </ol>


        <div class="box_general padding_bottom mb-5">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-info-circle"></i>Informações da Empresa
            </h2>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Nome da Empresa</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="empresa.nome_empresa"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>CNPJ</label>
                <input
                  type="text"
                  class="form-control"
                  v-mask="['##.###.###/####-##']"
                  v-model="empresa.CNPJ"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>CEP</label>
                <input
                  type="text"
                  class="form-control"
                  v-mask="['#####-###']"
                  v-model="empresa.CEP"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Cidade</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="empresa.cidade"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Estado</label>
                <v-select
                  label="sigla"
                  v-model="empresa.estado"
                  class="form-select"
                  :options="estados"
                  :searchable="true"
                >
                </v-select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Logradouro</label>
                <input
                  class="form-control"
                  v-model="empresa.logradouro"
                  type="text"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Bairro</label>
                <input
                  class="form-control"
                  v-model="empresa.bairro"
                  type="text"
                />
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label>Número</label>
                <input
                  class="form-control"
                  v-model="empresa.numero"
                  type="number"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>Selecione a cor (Escura)</label>
                <div class="horizontal">
                  <input
                    type="text"
                    class="form-control"
                    v-model="empresa.cor_site_escura"
                  />
                  <input
                    type="color"
                    class="form-control"
                    v-model="empresa.cor_site_escura"
                    style="width: 38px;"
                  />
                </div>  
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Selecione a cor (Média)</label>
                <div class="horizontal">
                  <input
                    type="text"
                    class="form-control"
                    v-model="empresa.cor_site_media"
                  />
                  <input
                    type="color"
                    class="form-control"
                    v-model="empresa.cor_site_media"
                    style="width: 38px;"
                  />
                </div>  
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Selecione a cor (Clara)</label>
                <div class="horizontal">
                  <input
                    type="text"
                    class="form-control"
                    v-model="empresa.cor_site_clara"
                  />
                  <input
                    type="color"
                    class="form-control"
                    v-model="empresa.cor_site_clara"
                    style="width: 38px;"
                  />
                </div>  
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
							<div class="form-group">
								<label>Adicione uma Logo (JPG, PNG)</label>
								<input
                  @change="changeLogo"
                  ref="addImagem"
                  type="file"
                  class="form-control"
                />
							</div>
						</div>
          </div>

        <div class="col-md-12 mb-4">
          <p>
            <button href="#0" class="btn_1 medium pull-right" @click="criarEmpresa()">Salvar</button>
          </p>
        </div>
      </div>
    </div>
  </div> <!-- /container-fluid-->
</div>
</template>

<script>
import { ajax, tratamento_requisicao, alerta, validaCampos, stripCNPJ } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";

export default {
  mixins: [funcoesGerais],
  data() {
    return {
      isLoading: false,
      empresa: {
        nome_empresa: '',
        CNPJ: '',
        CEP: '',
        cidade: '',
        estado: '',
        logradouro: '',
        bairro: '',
        numero: null,
        arquivo_logo: '',
        cor_site_escura: '',
        cor_site_media: '',
        cor_site_clara: ''
      },
      estados: [
        "AC", "AL", "AM", "AP", "BA", "CE", "DF", "ES", "GO", "MA", 
        "MG", "MS", "MT", "PA", "PB", "PE", "PI", "PR", "RJ", "RN", 
        "RO", "RR", "RS", "SC", "SE", "SP", "TO"
      ]
    };
  },

  methods: {
    changeLogo(event) {
      this.empresa.arquivo_logo = event.target.files[0];
    },
    criarEmpresa() {
      let self = this;

      if(validaCampos(undefined, self.empresa.CNPJ, undefined, undefined)) { 
        if(self.empresa.nome_empresa && self.empresa.CNPJ && self.empresa.CEP &&
        self.empresa.cidade && self.empresa.estado &&
        self.empresa.logradouro && self.empresa.bairro && self.empresa.numero &&
        self.empresa.arquivo_logo && self.empresa.cor_site_escura &&
        self.empresa.cor_site_media && self.empresa.cor_site_clara !== '') {
          self.isLoading = true;

          let objRequest = new FormData();

          objRequest.append('nome_empresa', self.empresa.nome_empresa);
          objRequest.append('CNPJ', stripCNPJ(self.empresa.CNPJ));
          objRequest.append('CEP', self.empresa.CEP);
          objRequest.append('cidade', self.empresa.cidade);
          objRequest.append('estado', self.empresa.estado);
          objRequest.append('logradouro', self.empresa.logradouro);
          objRequest.append('bairro', self.empresa.bairro);
          objRequest.append('numero', self.empresa.numero);
          objRequest.append('arquivo_logo', self.empresa.arquivo_logo);
          objRequest.append('cor_site_escura', self.empresa.cor_site_escura);
          objRequest.append('cor_site_media', self.empresa.cor_site_media);
          objRequest.append('cor_site_clara', self.empresa.cor_site_clara);
          
          ajax("post", "empresas", objRequest)
            .then(() => {
              self.isLoading = false;
              alerta(
                "success",
                "Sucesso",
                "Empresa cadastrada!"
              );
              self.$router.replace(this.$route.query.redirect || `/adm_master/empresas`);
            })
            .catch(error => {
              self.isLoading = false;
              tratamento_requisicao(error);
            });
        } else {
          alerta('warning', 'Atenção', 'Preencha todos os campos');
        }
      }
    },
  }
};
</script>